import { IFormSubmitStyleData } from "@pageBuilder/typings";
import { CssProperties, ICssProperty } from "../../../models/css-property";
import { AlignmentUtil } from "../../../utils/alignment-util";

export class FormSubmitStyleRenderer {

    public getStyles(style?: IFormSubmitStyleData): ICssProperty[] {
        const formSubmitStyle = new CssProperties();

        formSubmitStyle.tryAdd("--form-submit-text-color", style?.textColor);
        formSubmitStyle.tryAdd("--form-submit-background-color", style?.bgColor);

        formSubmitStyle.tryAdd("--form-submit-font-family", style?.font?.family ?? "");
        formSubmitStyle.tryAdd("--form-submit-font-weight", style?.font?.weight ?? "");

        if (style?.fitMode === "cover") {
            formSubmitStyle.tryAdd("--form-submit-width", "100%");
        } else {
            formSubmitStyle.tryAdd("--form-submit-width", "auto");
            formSubmitStyle.tryAdd("--form-submit-alignment", `${AlignmentUtil.correctAlignmentStyle(style?.alignment) ?? "start"}`);
        }

        if (style?.borderRadius) {
            formSubmitStyle.tryAdd("--form-submit-top-left-radius", `${style.borderRadius.topLeftPx}px`);
            formSubmitStyle.tryAdd("--form-submit-top-right-radius", `${style.borderRadius.topRightPx}px`);
            formSubmitStyle.tryAdd("--form-submit-bottom-left-radius", `${style.borderRadius.bottomLeftPx}px`);
            formSubmitStyle.tryAdd("--form-submit-bottom-right-radius", `${style.borderRadius.bottomRightPx}px`);
        }

        if (style?.borderWidth) {
            formSubmitStyle.tryAdd("--form-submit-border-color", style?.borderColor);
            formSubmitStyle.tryAdd("--form-submit-border-width", style?.borderWidth);

            formSubmitStyle.tryAdd("--form-submit-focus-border-color", style?.focusBorderColor);
        }

        formSubmitStyle.tryAdd("--form-submit-focus-background-color", style?.focusBgColor);
        formSubmitStyle.tryAdd("--form-submit-focus-text-color", style?.focusTextColor);

        return formSubmitStyle.data;
    }

}
